import { IParamsApi } from '@/types/apis/params';
import { IResponseApi } from '@/types/apis/response';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const cmsApiCaller = createApi({
  reducerPath: 'cmsApiCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CMS_API_END_POINT,
  }),
  endpoints: (builder) => ({
    getHolidayBanner: builder.query<IResponseApi.IGetHolidayBanner, IParamsApi.IGetHolidayBanner>({
      query: (input) => {
        return {
          url: 'banner/active',
          method: 'GET',
          params: input,
        };
      },
    }),
  }),
});
